"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Login/ForgotPassword/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reacthookform = require('react-hook-form');
var _useFieldErrorDisplay = require('shared/hooks/useFieldErrorDisplay'); var _useFieldErrorDisplay2 = _interopRequireDefault(_useFieldErrorDisplay);




var _forgotPassword = require('shared/validation/forgotPassword');

var _components = require('web/screens/Login/components');
var _Form = require('web/components/Form');
var _AuthFrame = require('web/components/AuthFrame');






const errorMsgs = {
  'Invalid Email': "Invalid email - please make sure you're using the email address you registered with BloomText when requesting a new password.",
  'Account Disabled': "This account has been disabled. Please contact support@bloomtext.com.",
  'generic': "Sorry, BloomText has encountered an error.",
}

const ForgotPassword = ({ gotoUsernameLogin, onSubmit }) => {
  const [hasRequestedRecovery, setHasRequestedRecovery] = _react.useState.call(void 0, false)

  // An empty or malformed email gets its sentence under the field instead
  // of a dead button: once they leave it after typing, or on submit, and
  // never while they type.
  const { register, setError, handleSubmit, formState } =
    _reacthookform.useForm({
      mode: 'onTouched',
      resolver: _forgotPassword.forgotPasswordResolver,
    })
  const { isSubmitting } = formState
  const display = _useFieldErrorDisplay2.default.call(void 0, { email: formState.errors.email })
  const { onSubmitErrors } = display

  const submit = _react.useCallback.call(void 0, 
    async (data, e) => {
      _optionalChain([e, 'optionalAccess', _ => _.preventDefault, 'call', _2 => _2()])

      return onSubmit(data.email)
        .then(() => setHasRequestedRecovery(true))
        .catch(e => {
          setError('email', { message: errorMsgs[e.Response] || errorMsgs.generic })
          onSubmitErrors(['email'])
        })
    },
    [onSubmit, setError, onSubmitErrors],
  )

  if (hasRequestedRecovery) {
    return (
      _react2.default.createElement(_components.FormWrapper, { title: "Check your email"  , onBack: gotoUsernameLogin, __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}
        , _react2.default.createElement('span', { className: "auth-icon-circle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}, _react2.default.createElement(_AuthFrame.MailIcon, { size: 26, __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}} ))
        , _react2.default.createElement('p', { className: "auth-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}, "We've sent you a message with instructions on how to reset your password."

        )
        , _react2.default.createElement(_Form.Button, { onClick: gotoUsernameLogin, __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}, "Done"

        )
      )
    )
  }

  return (
    _react2.default.createElement(_components.FormWrapper, { title: "Reset password" , onBack: gotoUsernameLogin, __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}
      , _react2.default.createElement('p', { className: "auth-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}, "Enter the email address associated with your BloomText account. We'll email you a reset link."


      )
      , _react2.default.createElement('form', { onSubmit: handleSubmit(submit, errs => onSubmitErrors(Object.keys(errs))), noValidate: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}
        , _react2.default.createElement(_Form.InputSection, {
          autoFocus: true,
          title: "Email",
          autoComplete: "email",
          inputType: "email",
          inputProps: display.bind(register('email')),
          placeholder: "name@clinic.com",
          errorMessage: _optionalChain([display, 'access', _3 => _3.shown, 'call', _4 => _4('email'), 'optionalAccess', _5 => _5.message]), __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}
        )
        , _react2.default.createElement(_Form.Button, {
          isSubmit: true,
          isLoading: isSubmitting, __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}
, "Send reset link"

        )
      )
    )
  )
}

exports. default = ForgotPassword
